module.exports = new __parcel__URL__("check.9c344ea4.svg").toString();